import _ from 'lodash';
import { View } from 'backbone.marionette';
import { User } from '../../../models';
import ErrorsModal from '../../../utils/ErrorsModal';
import Preloader from '../../../utils/Preloader';

export default class CoreCommunicationsView extends View {
	get template() {
		throw new Error("Need set template for child CoreAccountSettings class");
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	ui() {
		return {
			update_communications: '.js-update-communications',
			communications_form: '.js-communications-form',
			all_notifications: '.js-all-notifications'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.update_communications': 'updateCommunications',
			'click @ui.all_notifications': 'checkAllNotifications'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'user:update:errors': 'updateCommunicationsError',
			'user:update:success': 'updateCommunicationsSuccess'
		};
	}

	/**
	 * Initialize view data
	 */
	initialize() {
		this.model = User;
	}

	setAllFormData() {
		let form = this.getUI('communications_form'),
			form_data = form.serializeArray(),
			data = {};

		_.each(form_data, function(input) {
			data[input.name] = +input.value;
		});


		this.model.set(data);

		return this;
	}

	checkAllNotifications(element) {
		let all_notification = $(element.currentTarget).val();

		this.changeAllNotification(Number(all_notification));
	}

	changeAllNotification(off_all = true) {
		let form = this.getUI('communications_form')
			.find('.email-notifications input');

		_.each(form, element => {
			let val = $(element).val();

			if (off_all && !Number(val)) {
				$(element).trigger('click');
			}
			else if (!off_all && Number(val)) {
				$(element).trigger('click');
			}
		});
	}

	updateCommunications() {
		Preloader.show();
		this.setAllFormData();

		let data = _.pick(this.model.toJSON(),
			'disable_notifications',
			'game_emails',
			'weekly_updates',
			'weekly_reminders',
			'team_announcements',
			'draft_trade_propose',
			'draft_trade_request');


		this.model.updateUserData(data);
		return this;
	}

	updateCommunicationsSuccess() {
		alert('Communications updated');
		Preloader.hide();
	}

	updateCommunicationsError(errors) {
		Preloader.hide();
		ErrorsModal.show(errors);
	}
}